import { Grid, MenuItem, Select, TextField, Typography, makeStyles } from '@material-ui/core';
import React from 'react';
import { useSelector } from 'react-redux';
import UploadButton from '../journey/UploadButton';
import CustomUploadField from '../shared/CustomUploadField';
import { DIMENSIONS } from '../../constants/aspectRatio';
import Image from '../common/Image';
import QuillRichTextEditor from '../common/QuillRichTextEditor';

const useStyle = makeStyles({
  container: {
    padding: '20px 0px 20px 5px',
    display: 'flex',
    flexDirection: 'column',
    gap: '30px',
    height: '90%',
    overflowY: 'auto',
  },
  inputField: {
    width: '97%',
    height: '40px',
    borderRadius: '5px',
    marginTop: '5px',
    background: 'transparent',
  },
  upload: {
    border: '1px solid gray',
    padding: '10px',
    marginTop: '5px',
    width: '95%',
    borderRadius: '5px',
  },

  required_field: {
    color: '#667085',
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  option_field: {
    color: '#667085',
  },
});

export function TopicForm({
  form,
  setForm,
  image,
  setImage,
  setImageData,
  thumbnailImage,
  setThumbnailImage,
  thumbnailData,
  setThumbnailData,
}) {
  const classes = useStyle();
  const departments = useSelector((state) => state.getAllDepartments.departments);

  const handleFormChange = (event, type) => {
    setForm({
      ...form,
      [type]: event.target.value,
    });
  };
  const handleImageChange = (e) => {
    const filesData = e.target.files[0];
    setImageData(filesData);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setImage(ev.target.result);
    };
    reader.readAsDataURL(e.target.files[0]);
  };
  const handleThumbnailChange = (e) => {
    const file = e.target.files[0];
    setThumbnailData(file);
    const reader = new global.FileReader();
    reader.onload = (ev) => {
      setThumbnailImage(ev.target.result);
    };
    reader.readAsDataURL(file);
  };

  const handleDeleteThumbnail = () => {
    setThumbnailData('');
    setThumbnailImage('');
  };

  return (
    <Grid className={classes.container}>
      <Grid>
        <Typography className={classes.required_field}>Topic Name </Typography>
        <TextField
          variant="outlined"
          placeholder="Enter topic name"
          className={classes.inputField}
          value={form.title}
          onChange={(e) => handleFormChange(e, 'title')}
        />
      </Grid>
      <Grid>
        <Typography className={classes.required_field}>Topic Goal </Typography>
        <TextField
          variant="outlined"
          placeholder="Enter topic goal"
          className={classes.inputField}
          value={form.goal}
          onChange={(e) => handleFormChange(e, 'goal')}
        />
      </Grid>
      <Grid>
        <Typography className={classes.required_field}> What’s in it for me</Typography>
        <Grid item style={{ marginTop: '5px' }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item style={{ width: '97%' }}>
              <QuillRichTextEditor
                value={form.description}
                changeFn={(e) =>
                  setForm({
                    ...form,
                    description: e,
                  })
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Typography className={classes.required_field}>Departments </Typography>
        <Grid style={{ padding: '0px', width: '97%', marginTop: '5px' }}>
          <Select
            fullWidth
            variant="outlined"
            style={{ height: '55px' }}
            name="department"
            id="departmentId"
            value={form.departmentId}
            onChange={(e) =>
              setForm({
                ...form,
                departmentId: e.target.value,
              })
            }
            displayEmpty
          >
            <MenuItem
              value=""
              disabled
              selected
              style={{
                width: '100%',
                display: 'flex',
                justifyContent: 'left',
              }}
            >
              Select department
            </MenuItem>
            {departments?.map((dept) => (
              <MenuItem
                value={dept.id}
                key={dept.id}
                style={{
                  width: '100%',
                  display: 'flex',
                  justifyContent: 'left',
                }}
              >
                {dept.title}
              </MenuItem>
            ))}
          </Select>
        </Grid>
      </Grid>
      <Grid>
        <Typography style={{ color: '#667085' }}> PX Notes (if any)</Typography>
        <Grid item style={{ marginTop: '5px' }}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid item style={{ width: '97%' }}>
              <QuillRichTextEditor
                value={form.notes}
                changeFn={(e) => {
                  if (e !== form.notes) {
                    setForm({
                      ...form,
                      notes: e,
                    });
                  }
                }}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Typography className={classes.option_field}>Certificate Background</Typography>
        <Grid className={classes.upload}>
          <Grid container direction="row" justifyContent="space-between" alignItems="center">
            <Grid style={{ display: 'flex', gap: '5px', alignItems: 'center' }}>
              <Image alt="" src={image || ''} style={{ height: '26px' }} loading="lazy" />
            </Grid>
            <Grid>
              <UploadButton
                id="certificate"
                disableElevation
                className={classes.btnUploadStyle}
                handleImageUpload={handleImageChange}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Grid>
        <Typography className={classes.required_field}>Thumbnail</Typography>
        <CustomUploadField
          type="image"
          name="thumbnail"
          value={thumbnailData ? thumbnailImage : null}
          imgSrc={!thumbnailData ? thumbnailImage : null}
          handleChange={handleThumbnailChange}
          customStyles={{ width: '100%' }}
          fileName={thumbnailData?.name}
          dimensions={DIMENSIONS.tom}
          handleDelete={handleDeleteThumbnail}
        />
      </Grid>
    </Grid>
  );
}
